import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
        margin: "20px",
        color: "#333",
      }}
    >
      <a
        href="/"
        style={{
          display: "inline-block",
          marginBottom: "16px",
          color: "#2563eb",
          textDecoration: "none",
          fontSize: "14px",
        }}
      >
        ← Back to Login
      </a>

      <h1 style={{ fontSize: "28px", fontWeight: "bold", color: "black",marginBottom: "10px", }}>
        Privacy Policy
      </h1>

      <p>
        Perambalur Compost Shed Management App ("we", "our", or "us") is a smart
        waste management application developed to support solid waste collection,
        monitoring, and reporting for Perambalur District. Your privacy matters,
        and this policy explains clearly what data we collect, why we collect it,
        and how it is used.
      </p>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black",marginBottom: "10px",marginTop: "10px" }}>
        Information We Collect
      </h2>

      <p>The application collects only the information required to operate its core functionality:</p>

      <ul style={{ marginLeft: "20px", listStyleType: "disc" }}>
        <li><strong>User Credentials:</strong> Username and login details for authorized access.</li>
        <li><strong>Waste Entry Data:</strong> Waste type, quantity (kg), date, block, panchayat, and vehicle details.</li>
        <li><strong>Vehicle Information:</strong> Vehicle number used during waste entry.</li>
        <li><strong>Photos (Optional):</strong> Images captured during waste entry if the user chooses to upload them.</li>
      </ul>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black",marginBottom: "10px",marginTop: "10px" }}>
        How We Use the Information
      </h2>

      <ul style={{ marginLeft: "20px", listStyleType: "disc" }}>
        <li>Recording and tracking daily waste collection</li>
        <li>Generating dashboards, insights, and reports</li>
        <li>Monitoring waste types and quantities</li>
        <li>Administrative review and compliance</li>
      </ul>

      <p>We do not use your data for advertising or marketing.</p>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black", marginBottom: "10px",marginTop: "10px" }}>
        Data Sharing
      </h2>

      <p>
        We do <strong>not</strong> sell, rent, or share personal data with third
        parties. Data is accessible only to authorized personnel for official
        waste management purposes.
      </p>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black",marginBottom: "10px",marginTop: "10px" }}>
        Data Storage and Security
      </h2>

      <p>
        All collected data is stored securely on managed servers with reasonable
        safeguards against unauthorized access.
      </p>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black",marginBottom: "10px",marginTop: "10px" }}>
        Permissions Used
      </h2>

      <ul style={{ marginLeft: "20px", listStyleType: "disc" }}>
        <li><strong>Camera:</strong> To capture waste photos (optional).</li>
        <li><strong>Internet:</strong> To sync waste records and dashboards.</li>
      </ul>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black",marginBottom: "10px",marginTop: "10px" }}>
        User Responsibility
      </h2>

      <p>Users are responsible for maintaining the confidentiality of login credentials.</p>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black",marginBottom: "10px",marginTop: "10px" }}>
        Children’s Privacy
      </h2>

      <p>This application is not designed for children under 13.</p>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black",marginBottom: "10px",marginTop: "10px" }}>
        Changes to This Policy
      </h2>

      <p>Updates will be reflected on this page.</p>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", color: "black",marginBottom: "10px",marginTop: "10px" }}>
        Contact Information
      </h2>

      <p>
        <strong>Organization:</strong> Perambalur Compost Shed Management
        <br />
        <strong>Technology Partner:</strong> Circular Carbon Technologies Pvt. Ltd.
      </p>

      <p><em>Last updated: December 29, 2025</em></p>
    </div>
  );
}
